﻿import { useUserContext } from "@/providers";

export function useIsProjectRequestor(requestorId: string) {
  const { userToken } = useUserContext();
  return requestorId === userToken.user.id;
}
